export const COMPANY = {
  name: "HOUSTO A/C",
  tagline: "Keeping Houston Cool, All Year Long.",
  phoneDisplay: "(346) 599-0866",
  phoneHref: "tel:3465990866",
  email: "info@houstoac.com",
  cities: ["Houston", "Katy", "Sugar Land", "Pearland", "Cypress", "The Woodlands", "Spring", "Humble"],
};

export const GALLERY = [
  {
    url: "https://customer-assets.emergentagent.com/job_cool-houston-ac/artifacts/998evrhp_IMG-20250813-WA0010.JPG",
    alt: "Indoor mini-split installed on rustic wood accent wall",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_cool-houston-ac/artifacts/gfe6g3tz_20250911_182556.JPG",
    alt: "Outdoor mini-split with refrigerant line on grey siding",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_cool-houston-ac/artifacts/8e8ngzgq_IMG-20250813-WA0009.JPG",
    alt: "Outdoor condenser unit with vertical refrigerant line",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_cool-houston-ac/artifacts/16zpdiz4_20260403_115431.JPG",
    alt: "Residential outdoor AC condenser on concrete pad",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_cool-houston-ac/artifacts/e5m8dg4e_20260428_115554.JPG",
    alt: "Goodman air handler and ductwork in attic",
  },
];

export const HERO_IMAGE = "https://static.prod-images.emergentagent.com/jobs/93819834-a125-4055-b66a-381b8bac980f/images/ac692e9aa316a72c35e12b5c7c3b0ba4c3120f52187a18075f2c4b43e865167a.png";

// Icons referenced by index (parallel to t.services.items / t.why.items)
export const SERVICES_ICONS = ["Wind", "Snowflake", "Fan", "GitBranch", "Wrench", "ShieldCheck"];
export const WHY_ICONS = ["Zap", "ShieldCheck", "Building2", "Calculator"];
export const VALUES_ICONS = ["Heart", "Hammer", "ShieldCheck", "Star"];

export const GOOGLE_REVIEWS_URL = "https://www.google.com/search?q=HOUSTO+A%2FC+Houston+TX+reviews";
